// extracted by mini-css-extract-plugin
export default {"cls1":"Header-cls1__Jr","cls2":"Header-cls2__HB Header-cls1__Jr"};